module.exports = __webpack_public_path__ + "media/images/flags/32/Montserrat-68f264aca3ec65d9c6cd157d9ddf7550.png";